import React from 'react';
import { NumberInput, BooleanInput, required, minValue, maxValue } from 'react-admin';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslate } from '../common/language';

export const SubscriptionPricingInputs = () => {
  const translate = useTranslate();
  return (
    <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 2, my: 2 }}>
      <Typography variant="h6" gutterBottom>{translate('settings.service_block_subscriptions')}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <NumberInput fullWidth source="subscriptions_vat_percent" label={translate('settings.subscriptions_vat_percent_default')} step={0.01} validate={[required(), minValue(0), maxValue(100)]} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <BooleanInput source="subscriptions_vat_included" label={translate('settings.subscriptions_vat_included')} />
        </Grid>
        <Grid item xs={12}>
          <BooleanInput source="subscriptions_management_fees_included" label={translate('settings.subscriptions_management_fees_included')} />
        </Grid>
      </Grid>
    </Box>
  );
};
